import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import VPagination from "@hennge/vue3-pagination";
import SDVModal from "../SDV_VerificationModal/SDV_VerificationModal.vue";
import ListSdvQueryModal from "../ListSdvQueryModal/ListSdvQueryModal.vue";

export default {
    name: "sdvSummary",
    components: {
        VPagination,
        SDVModal,
        ListSdvQueryModal
    },

    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            idToken: store.getters.getIdToken,
            showBlock: [true, false],
            defaultdate: "",
            defaultTime: "",
            headerValues: {},
            showTableLoading: false,
            sdvList: { Data: [], Total: 0 },
            formSdvList: { entities: [], totalCount: 0 },
            totalPage: 1,
            currentPage: 1,
            sites: [],

            summaryTiles: {
                totalSdvRecords: 0,
                verifiedCount: 0,
                discrepancyCount: 0,
                pendingCount: 0,
                verifiedPercentage: 0,
                discrepancyPercentage: 0,
                pendingPercentage: 0
            },

            searchData: {
                PageNumber: 1,
                PageSize: 10,
                SortBy: "CreatedAt",
                SortOrder: "desc",
                SiteId: "",
                Status: "",
                FromDate: null,
                ToDate: null,
            },

            formSearchData: {
                SortBy: "siteCode",
                SortOrder: "asc",
            },

            sdv: {},
            showSDVModal: false,
            showQueryModal: false,
            selectedId: "",
            selectedDataRef: [],
            selectedModalType: "",
            selectedFromTab: "",
            rollsprivilages: "",
        };
    },

    async mounted() {
        this.rollsprivilages = await store.getters.getRolesprivilegeData;
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + this.idToken,
                "Content-Type": "application/json",
            },
        };
        this.defaultdate = localStorage.getItem("dateformat");
        this.defaultTime = localStorage.getItem("timeformat");

        window.addEventListener("studyIdChanged", async () => {
            this.studyId = store.getters.getStudyIs;
            await this.getSites();
            await this.getSummaryTiles();
            await this.getFormSDVList();
        });

        this.studyId = store.getters.getStudyIs;
        await this.getSites();
        await this.getSummaryTiles();
        // await this.getSDVList(); // DataSignal tab disabled for now
        await this.getFormSDVList();
    },

    methods: {
        activatedtab() {
            return this.showBlock[0] == true ? "activeTab" : "inactive";
        },

        async getSites() {
            try {
                const res = await axios.get(
                    `${this.baseurl}/management/site/getallsitesbyuser?studyId=${this.studyId}`,
                    this.headerValues
                );
                this.sites = res.data || [];
            } catch (error) {
                console.error("Error fetching sites:", error);
                this.sites = [];
            }
        },

        async selectDataSignalTab() {
            this.showBlock[0] = true;
            this.showBlock[1] = false;
            this.searchData.PageNumber = 1;
            await this.getSDVList();
        },

        async selectFormSdvTab() {
            this.showBlock[1] = true;
            this.showBlock[0] = false;
            this.searchData.PageNumber = 1;
            await this.getFormSDVList();
        },

        async getSDVList() {
            this.showTableLoading = true;
            try {
                let url = `${this.baseurl}/stats-python/formstatistics/getallsdv`
                    + `?PageNumber=${this.searchData.PageNumber}`
                    + `&PageSize=${this.searchData.PageSize}`
                    + `&SortBy=CreatedAt`
                    + `&SortOrder=desc`
                    + `&StudyId=${this.studyId}`
                    + `&SiteId=${this.searchData.SiteId || ""}`
                    + `&Status=${this.searchData.Status || ""}`;

                if (this.searchData.FromDate) {
                    url += `&FromDate=${this.searchData.FromDate}`;
                }
                if (this.searchData.ToDate) {
                    url += `&ToDate=${this.searchData.ToDate}`;
                }

                const res = await axios.get(url, this.headerValues);
                this.showTableLoading = false;
                this.sdvList = res.data;
                this.totalPage = parseInt(this.sdvList.Total / this.searchData.PageSize);
                if (this.searchData.PageSize % this.pagesize != 0) {
                    this.totalPage = this.totalPage + 1;
                }
            } catch (error) {
                this.showTableLoading = false;
                console.error("Error fetching SDV List:", error);
            }
        },

        async getFormSDVList() {
            this.showTableLoading = true;
            try {
                let url = `${this.baseurl}/forms/managesdv/getallsdv`
                    + `?Studyid=${this.studyId}`
                    + `&pageindex=${this.searchData.PageNumber}`
                    + `&pagesize=${this.searchData.PageSize}`
                    + `&SortProperty=${this.formSearchData.SortBy}`
                    + `&SortOrder=${this.formSearchData.SortOrder === "asc" ? 1 : 0}`;

                if (this.searchData.SiteId) {
                    url += `&siteId=${this.searchData.SiteId}`;
                }
                if (this.searchData.Status) {
                    url += `&overallStatus=${this.searchData.Status}`;
                }
                if (this.searchData.FromDate) {
                    url += `&FromDate=${this.filterDate(this.searchData.FromDate)}`;
                }
                if (this.searchData.ToDate) {
                    url += `&ToDate=${this.filterDate(this.searchData.ToDate)}`;
                }

                const res = await axios.get(url, this.headerValues);
                this.showTableLoading = false;
                this.formSdvList = res.data;
                this.totalPage = parseInt(this.formSdvList.totalCount / this.searchData.PageSize);
                if (this.formSdvList.totalCount % this.searchData.PageSize != 0) {
                    this.totalPage = this.totalPage + 1;
                }
            } catch (error) {
                this.showTableLoading = false;
                console.error("Error fetching Form SDV List:", error);
            }
        },

        SortFormSelected(prop) {
            if (this.formSearchData.SortBy === prop) {
                this.formSearchData.SortOrder = this.formSearchData.SortOrder === "asc" ? "desc" : "asc";
            } else {
                this.formSearchData.SortBy = prop;
                this.formSearchData.SortOrder = "asc";
            }
            this.searchData.PageNumber = 1;
            this.currentPage = 1;
            this.getFormSDVList();
        },

        loadPage: function (page) {
            this.currentPage = page;
            this.searchData.PageNumber = page;
            // Form SDV only for now
            this.getFormSDVList();
            // if (this.showBlock[0] === true) {
            //     this.getSDVList();
            // } else {
            //     this.getFormSDVList();
            // }
        },

        async search() {
            this.searchData.PageNumber = 1;
            await this.getFormSDVList();
            await this.getSummaryTiles();
        },

        filter(data) {
            if (data) {
                return moment(data).format(this.defaultdate);
            }
        },

        filterDate(data) {
            if (!data) {
                return null;
            }
            return moment(data).utc().format("YYYY-MM-DDTHH:mm:ss[Z]");
        },

        async openSDVModal(sdvRecord, modalType, fromTab) {
            this.selectedId = sdvRecord.id;
            this.selectedModalType = modalType;
            this.selectedFromTab = fromTab;
            this.showSDVModal = true;
        },

        Closequerypopup() {
            this.querypopup = false;
        },

        async closeSDVModal() {
            this.showSDVModal = false;
        },
        async onSdvUpdated() {
            await this.getFormSDVList();
            await this.getSummaryTiles();
        },
        async closeQueryModal() {
            this.showQueryModal = false;
        },

    async getSummaryTiles() {
    try {
        let url = `${this.baseurl}/forms/managesdv/getsitesdvreport?studyId=${this.studyId}`;
        if (this.searchData.SiteId) {
            url += `&siteId=${this.searchData.SiteId}`;
        }

        const res = await axios.get(url, this.headerValues);
        this.summaryTiles = res.data;

        const siteReport = res.data.siteWiseReport || [];
        this.openQueriesBySite = siteReport.map((site) => ({
            siteCode: site.siteCode,
            count: (site.discrepancyCount || 0) + (site.pendingCount || 0),
            percentage: site.verifiedPercentage || 0
            // verifiedpercentage:site.verifiedPercentage
        }));

    } catch (error) {
        console.error("Error fetching SDV summary tiles:", error);
        this.summaryTiles = {
            totalSdvRecords: 0,
            verifiedCount: 0,
            discrepancyCount: 0,
            pendingCount: 0,
            verifiedPercentage: 0,
            discrepancyPercentage: 0,
            pendingPercentage: 0
        };
        this.openQueriesBySite = [];
    }
},
    }
};